import React, { Component } from 'react'
import Dialog from 'material-ui/Dialog'
import FlatButton from 'material-ui/FlatButton'
import api from '../../api'

class DownloadLink extends Component<any, any> {
  constructor (props) {
    super(props)
    this.state = {
      template: null
    }
  }

  createTemplate = () => {
    api.post(this.props.templatePath)
      .then(res => res.json())
      .then(template => {
        this.setState({
          template
        })
      })
  }

  closeTemplateDialog = () => {
    this.setState({
      template: null
    })
  }

  render () {
    return (
      <div>
        <a onClick={this.createTemplate}>
            Start by downloading this CSV template
        </a> and then opening it in a spreadsheet program such as Microsoft Excel.

        {
          this.state.template &&
            <Dialog
              title='Download CSV Template'
              modal={false}
              open={this.state.template !== null}
              actions={[
                <FlatButton
                  label='Close'
                  primary
                  onClick={this.closeTemplateDialog}
                />
              ]}
              onRequestClose={this.closeTemplateDialog}
            >
              <a href={this.state.template.url}>
                {this.state.template.filename}
              </a>
            </Dialog>
        }

      </div>
    )
  }
}

export default DownloadLink
